import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Button,
} from "reactstrap"

import { Link, useNavigate, useParams } from "react-router-dom"
import leftArrow from "../../assets/images/icons/left-arrow.svg"
import IndividualView from "./individualView"
import NonIndividualView from "./nonIndividualView"
import KycRejectConfirmationModal from "./confirm/kycRejectConfirmation"
import KycApproveConfirmationModal from "./confirm/kycApproveConfirmation"
import { getInvestorsStatus } from "helpers/common"
import KycRaiseQuery from "./confirm/kycRaiseQuery"
import LoaderComponent from "components/loader"
import {
  useApproveKYCSubmissionPartnerMutation,
  useLazyGetWealthPartnerQuery,
  useRaiseQueryKYCPartnerMutation,
  useRejectKYCSubmissionPartnerMutation,
} from "store/api/wealth-partner/wealth-partners.api"
import Breadcrumb from "components/Common/Breadcrumb"
import RaisedQueries from "pages/Investors/raisedQueries"

const ViewInvestor = () => {
  const { id } = useParams()
  const history = useNavigate()
  const [getResult, { isFetching }] = useLazyGetWealthPartnerQuery()
  const [partnerData, setPartnerData] = useState(null)
  const [raiseQuery, setRaiseQuery] = useState(false)
  const [isToast, setIsToast] = useState(false)
  const [actionType, setActionType] = useState() //APPROVE,REJECT

  const [onApprove, { isLoading: isApproving }] =
    useApproveKYCSubmissionPartnerMutation()
  const [onReject, { isLoading: isRejecting }] =
    useRejectKYCSubmissionPartnerMutation()
  const [onRaise, { isLoading: isRaising }] = useRaiseQueryKYCPartnerMutation()

  useEffect(() => {
    if (partnerData) {
      if (partnerData.status === "LINK_SENT") {
        history(`/investors/invite/${id}`)
      }
    }
  }, [partnerData])

  useEffect(() => {
    if (id) {
      getPartnerData()
    }
  }, [id])

  const getPartnerData = async () => {
    const { data } = await getResult({ id }).unwrap()
    setPartnerData(data)
  }

  document.title = "Wealth Partner Details  | Prachay"

  return (
    <React.Fragment>
      <div className="page-content">
        {isFetching ? (
          <LoaderComponent />
        ) : (
          <Container fluid>
            <Breadcrumb title="Wealth Partner Details" />
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody className="pt-4">
                    <div className="d-flex align-items-center mb-4 justify-content-between">
                      <CardTitle className="mt-5 pt-2">
                        {partnerData && partnerData.entity_type === "INDIVIDUAL"
                          ? "Personal Details"
                          : "Entity Details"}
                      </CardTitle>
                      {partnerData && (
                        <div className="code-status">
                          {getInvestorsStatus(
                            partnerData?.status,
                            partnerData.deleted_at
                          )}
                        </div>
                      )}
                    </div>
                    {partnerData &&
                      partnerData.entity_type === "INDIVIDUAL" && (
                        <IndividualView partnerData={partnerData} />
                      )}
                    {partnerData && partnerData.entity_type === "COMPANY" && (
                      <NonIndividualView partnerData={partnerData} />
                    )}
                  </CardBody>
                </Card>

                {partnerData?.kycRaisedQueries.length > 0 && (
                  <Card>
                    <CardBody className="pt-4">
                      <div className="d-flex align-items-center mb-4 justify-content-between">
                        <CardTitle className="">Raised Queries</CardTitle>
                      </div>
                      <RaisedQueries
                        investorData={partnerData}
                        data={partnerData?.kycRaisedQueries}
                      />
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>

            <Row>
              <Col xl={12}>
                {partnerData?.kyc_status === "SUBMITTED" &&
                  partnerData?.status === "UNDER_REVIEW" && (
                    <>
                      <div className="buttons button-wrapper buttons">
                        <button
                          className="btn cancel"
                          style={{
                            color: "#035CA1",
                            borderColor: "#035CA1",
                            minWidth: "200px",
                          }}
                          onClick={() => {
                            setRaiseQuery(true)
                          }}
                        >
                          Raise Query
                        </button>
                        {/* <Button
                          className="reject"
                          onClick={() => {
                            setIsToast(true)
                            setActionType("REJECT")
                          }}
                        >
                          Reject
                        </Button> */}
                        <Button
                          className="approve"
                          onClick={() => {
                            setIsToast(true)
                            setActionType("APPROVE")
                          }}
                        >
                          Approve
                        </Button>
                      </div>

                      {partnerData && isToast && actionType === "APPROVE" && (
                        <KycApproveConfirmationModal
                          open={isToast}
                          id={partnerData.id}
                          setOpen={setIsToast}
                          isLoading={isApproving}
                          onClose={() => {
                            setIsToast(false)
                            setActionType("")
                          }}
                          onApprove={onApprove}
                          onSuccess={getPartnerData}
                        />
                      )}

                      {partnerData && isToast && actionType === "REJECT" && (
                        <KycRejectConfirmationModal
                          open={isToast}
                          id={partnerData.id}
                          setOpen={setIsToast}
                          isLoading={isRejecting}
                          onClose={() => {
                            setIsToast(false)
                            setActionType("")
                          }}
                          onReject={onReject}
                          onSuccess={getPartnerData}
                        />
                      )}
                      {partnerData && raiseQuery && (
                        <KycRaiseQuery
                          open={raiseQuery}
                          partnerData={partnerData}
                          id={partnerData.id}
                          entityType={partnerData.entity_type}
                          setOpen={setRaiseQuery}
                          isLoading={isRaising}
                          onClose={() => {
                            setRaiseQuery(false)
                          }}
                          onSubmit={onRaise}
                          onSuccess={getPartnerData}
                        />
                      )}
                    </>
                  )}
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </React.Fragment>
  )
}

export default ViewInvestor
